import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=e31744bc&scoped=true&"
import script from "./DeleteBtn.vue?vue&type=script&lang=ts&"
export * from "./DeleteBtn.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteBtn.vue?vue&type=style&index=0&id=e31744bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31744bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
